import { FC, PropsWithChildren, useEffect, useState } from 'react';

import { SplashScreen } from '@/shared/ui/components/SplashScreen';

import { useErrorEffect } from '@/shared/lib/errors';
import { useAppDispatch } from '@/shared/lib/redux';

import {
  updateGeneralClassifiers,
  useGetClassifiers
} from '@/entities/classifiers';

/**
 * Обертка для получения классификаторов перед загрузкой приложения
 * @param root0 Пропсы
 * @param root0.children Дочерние компоненты
 */
export const Classifiers: FC<PropsWithChildren> = ({ children }) => {
  const [isAppReady, setIsAppReady] = useState(false); // Состояние готовности приложения. Зависит от
  // наличия классификаторов в Redux. Если они еще не подгрузились в стор,
  // а приложение уже отрисовывается, то будут ломаться страницы

  const dispatch = useAppDispatch();

  const { isLoading, error, generalClassifiers } = useGetClassifiers();

  useEffect(() => {
    if (generalClassifiers) {
      dispatch(updateGeneralClassifiers(generalClassifiers));
      setIsAppReady(true);
    }
  }, [generalClassifiers]);

  useErrorEffect(error);

  return isLoading || !isAppReady ? <SplashScreen /> : children;
};
